<template>
  <div class="main-content">
    <!-- 左侧课程分类导航 -->
    <div class="left-sidebar">
      <div v-for="(course, index) in displayCourseList" :key="course.id" :class="['course-nav-item', { active: selectedCourseId == course.id }]" @click="handleSelectCourse(course)">
        <div class="course-name">{{ course.name }}</div>
        <div class="course-types">
          <span v-for="type in course.types" :key="type" :class="['type-tag', courseType[parseInt(type) - 1] == '直播课' ? 'live-tag' : 'record-tag']">
            {{ courseType[parseInt(type) - 1] }}
          </span>
        </div>
      </div>
      <div v-if="shouldShowMoreButton" class="more-courses" @click="showMoreCourses">
        {{ showAllCourses ? '收起课程' : '更多课程' }}
        <span class="arrow" :style="{ transform: showAllCourses ? 'rotate(180deg)' : 'rotate(0deg)' }">∨</span>
      </div>
    </div>
    <div class="right-content">
      <div class="section-header-wrapper">
        <div class="section-header">
          <span @click="togglePastCourseMode" class="history-title">{{ isPastCourseMode ? '返回当前课程' : '往期课程' }}</span>
          <div v-if="isPastCourseMode" @click="togglePastCourseMode">
            <img style="width: 12px; height: 14px;margin-left: 5px;" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/98.png" alt="">
          </div>
          <div v-else class="eye-icon" @click="togglePastCourseMode">👁</div>
        </div>
      </div>
      <div v-if="isPastCourseMode && yearList.length > 0" class="year-selector-wrapper">
        <div class="year-selector">
          <div v-for="year in yearList" :key="year" :class="['year-item', { active: selectedYear === year }]" @click="handleSelectYear(year)">
            {{ year }}
          </div>
        </div>
      </div>
      <div class="chapter-list">
        <!-- 往期课程列表 -->
        <template v-if="isPastCourseMode">
          <div v-for="course in pastCourses" :key="course.id" class="chapter-item">
            <div class="chapter-main">
              <div class="chapter-left">
                <div class="chapter-row">
                  <span :class="['type-badge', course.type == '直播课' || course.type == 1 ? 'live-badge' : 'record-badge']">
                    {{ course.type == 1 ? '直播课' : course.type == 2 ? '录播课' : course.type }}
                  </span>
                  <div class="chapter-name">{{ course.title || course.name }}</div>
                </div>
                <div class="chapter-row">
                  <div class="chapter-stats">
                    <span class="stat-item">共{{ course.chapterNewVOS ? course.chapterNewVOS.length : course.chapterCount || 0 }}章</span>
                    <span class="stat-item">学习率：{{ course.recordStudy || course.studyRate || 0 }}%</span>
                  </div>
                </div>
              </div>
              <div class="chapter-right">
              
                <el-button v-if="course.courseDocFlag == 1" class="action-btn" @click="handleOpenCourseMaterial(course)">课程资料</el-button>
                <el-button v-if="course.courseTestFlag == 1" class="action-btn" @click="handleOpenCourseTest(course)">课程测试</el-button>
                <div class="expand-toggle" @click="handleToggleChapter(course)">
                  <span>{{ course.expanded ? '收起' : '展开' }}</span>
                  <img :class="['expand-arrow', course.expanded ? 'up' : 'down']" :src="course.expanded ? 'https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/101.png' : 'https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/100.png'" alt="" />
                </div>
              </div>
            </div>
            <!-- 展开的章节详情 -->
            <div v-if="course.expanded" class="chapter-details">
              <!-- 直播课：显示小节项样式 -->
              <template v-if="course.type == '直播课' || course.type == 1">
                <div v-for="section in course.sections || []" :key="section.id" class="section-item live-section">
                  <div class="live-section-left-wrapper">
                    <div class="live-section-top">
                      <span class="video-icon">
                        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/97.png" alt="">
                      </span>
                      <span class="section-name">{{ section.sectionName || section.name }}</span>
                      <span class="video-tag">
                        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/95.png" alt="">
                        回放
                      </span>
                    </div>
                    <div class="live-section-bottom">
                      <span class="section-time" v-if="section.startTime">🕐 {{ formatDate(section.startTime) }}</span>
                      <div class="progress-bar">
                        <div class="progress-fill" :style="{ width: (section.studyRate || 0) + '%' }"></div>
                      </div>
                      <span class="status-tag">{{ section.studyRate >= 100 ? '已完成' : '学习中' }}</span>
                    </div>
                  </div>
                  <div v-if="course.productLine !== '1'" class="live-section-right">
                    <el-button v-if="section.docList && section.docList.length > 0" class="action-btn" @click.stop="handleGoData(section, 9, course)">随堂讲义</el-button>
                    <el-button v-if="section.testList && section.testList.length > 0" class="action-btn" @click.stop="handleCheckTask(section)">随堂测试</el-button>
                    <el-button v-if="section.resourceList && section.resourceList.length > 0" class="action-btn" @click.stop="handleGoData(section, 1, course)">随堂资料</el-button>
                    <el-button class="study-btn" @click="section.liveStatus ? handleCheckXbk(section, course) : handleCheck(section, course)">去学习</el-button>
                  </div>
                  <div v-else class="live-section-right">
                    <el-button class="study-btn" @click="section.liveStatus ? handleCheckXbk(section, course) : handleCheck(section, course)">去学习</el-button>
                  </div>
                </div>
              </template>

              <!-- 录播课：显示子章节结构 -->
              <template v-else>
                <div v-for="(subChapter, index) in course.chapterNewVOS || []" :key="'sub-' + subChapter.id || index" class="sub-chapter-item">
                  <div class="sub-chapter-header">
                    <span class="sub-chapter-icon">
                      <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/93.png" alt="">
                    </span>
                    <span class="sub-chapter-name">{{ subChapter.sectionName || subChapter.name || subChapter.title || '未命名章节' }}</span>
                    <div v-if="!subChapter.isshow" class="sub-expand-toggle" @click="handleIfShow(subChapter, 1, course)">
                      <span>展开</span>
                      <img class="expand-arrow down" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/100.png" alt="" />
                    </div>
                    <div v-else class="sub-expand-toggle" @click="handleIfShow(subChapter, 2, course)">
                      <span>收起</span>
                      <img class="expand-arrow up" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/101.png" alt="" />
                    </div>
                  </div>
                  <div v-if="subChapter.isshow" class="sub-chapter-content">
                    <div v-if="subChapterLoading" class="loading-container">
                      <i class="el-icon-loading"></i>
                      <span>加载中...</span>
                    </div>
                    <template v-else>
                      <div v-for="(lesson, lessonIndex) in gchapterVOList" :key="'lesson-' + lesson.id || lessonIndex" class="lesson-item">
                        <div class="lesson-left-wrapper">
                          <div class="lesson-top">
                            <span class="video-icon">
                              <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/97.png" alt="">
                            </span>
                            <span class="lesson-name">{{ lesson.sectionName || lesson.name || lesson.title || '未命名课时' }}</span>
                          </div>
                          <div class="lesson-bottom">
                            <div class="progress-bar">
                              <div class="progress-fill" :style="{ width: (lesson.studyRate || 0) + '%' }"></div>
                            </div>
                            <span class="status-tag">{{ lesson.studyRate >= 100 ? '已完成' : '学习中' }}</span>
                          </div>
                        </div>
                        <div v-if="course.productLine !== '1'" class="lesson-right">
                          <el-button v-if="lesson.docList && lesson.docList.length > 0" class="action-btn" @click.stop="handleGoData(lesson, 2, course)">随堂讲义</el-button>
                          <el-button v-if="lesson.testList && lesson.testList.length > 0" class="action-btn" @click.stop="handleCheckTask(lesson)">随堂测试</el-button>
                          <el-button v-if="lesson.resourceList && lesson.resourceList.length > 0" class="action-btn" @click.stop="handleGoData(lesson, 1, course)">随堂资料</el-button>
                          <el-button class="study-btn" @click="handleChecks(lesson, course, lessonIndex)">去学习</el-button>
                        </div>
                        <div v-else class="lesson-right">
                          <el-button class="study-btn" @click="handleChecks(lesson, course, lessonIndex)">去学习</el-button>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <!-- 正常课程列表 -->
        <template v-else>
          <div v-for="chapter in currentChapters" :key="chapter.id" class="chapter-item">
            <div class="chapter-main">
              <div class="chapter-left">
                <div class="chapter-row">
                  <span :class="['type-badge', chapter.type == '直播课' ? 'live-badge' : 'record-badge']">
                    {{ chapter.type }}
                  </span>
                  <div class="chapter-name">{{ chapter.name }}</div>
                </div>
                <div class="chapter-row">
                  <div class="chapter-stats">
                    <span class="stat-item">共{{ chapter.chapterCount }}章</span>
                    <span class="stat-item">学习率：{{ chapter.studyRate }}%</span>
                  </div>
                </div>
              </div>
              <div class="chapter-right">
             
                <el-button v-if="chapter.courseDocFlag == 1" class="action-btn" @click="handleOpenCourseMaterial(chapter)">课程资料</el-button>
                <el-button v-if="chapter.courseTestFlag == 1" class="action-btn" @click="handleOpenCourseTest(chapter)">课程测试</el-button>
                <div class="expand-toggle" @click="handleToggleChapter(chapter)">
                  <span>{{ chapter.expanded ? '收起' : '展开' }}</span>
                  <img :class="['expand-arrow', chapter.expanded ? 'up' : 'down']" :src="chapter.expanded ? 'https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/101.png' : 'https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/100.png'" alt="" />
                </div>
              </div>
            </div>
            <!-- 展开的章节详情 -->
            <div v-if="chapter.expanded" class="chapter-details">
              <!-- 直播课：显示小节项样式（图一） -->
              <template v-if="chapter.type == '直播课'">
                <div v-for="section in chapter.sections" :key="section.id" class="section-item live-section">
                  <div class="live-section-left-wrapper">
                    <div class="live-section-top">
                      <span class="video-icon">
                        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/97.png" alt="">
                      </span>
                      <span class="section-name">{{ section.sectionName || section.name }}</span>
                      <span class="video-tag">
                        <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/95.png" alt="">
                         回放
                      </span>
                    </div>
                    <div class="live-section-bottom">
                      <span class="section-time" v-if="section.startTime">🕐 {{ formatDate(section.startTime) }}</span>
                      <div class="progress-bar">
                        <div class="progress-fill" :style="{ width: (section.studyRate || 0) + '%' }"></div>
                      </div>
                      <span class="status-tag">{{ section.studyRate >= 100 ? '已完成' : '学习中' }}</span>
                    </div>
                  </div>
                  <div v-if="chapter.productLine !== '1'" class="live-section-right">
                    <el-button v-if="section.docList && section.docList.length > 0" class="action-btn" @click.stop="handleGoData(section, 9, chapter)">随堂讲义</el-button>
                    <el-button v-if="section.testList && section.testList.length > 0" class="action-btn" @click.stop="handleCheckTask(section)">随堂测试</el-button>
                    <el-button v-if="section.resourceList && section.resourceList.length > 0" class="action-btn" @click.stop="handleGoData(section, 1, chapter)">随堂资料</el-button>
                    <el-button class="study-btn" @click="section.liveStatus ? handleCheckXbk(section, chapter) : handleCheck(section, chapter)">去学习</el-button>
                  </div>
                  <div v-else class="live-section-right">
                    <el-button class="study-btn" @click="section.liveStatus ? handleCheckXbk(section, chapter) : handleCheck(section, chapter)">去学习</el-button>
                  </div>
                </div>
              </template>

              <!-- 录播课：显示子章节结构（图二） -->
              <template v-else>
                <!-- 可折叠的子章节 -->
                <div v-for="(subChapter, index) in chapter.chapterNewVOS" :key="'sub-' + subChapter.id || index" class="sub-chapter-item">
                  <div class="sub-chapter-header">
                    <span class="sub-chapter-icon">
                      <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/93.png" alt="">
                    </span>
                    <span class="sub-chapter-name">{{ subChapter.sectionName || subChapter.name || subChapter.title || '未命名章节' }}</span>
                    <div v-if="!subChapter.isshow" class="sub-expand-toggle" @click="handleIfShow(subChapter, 1, chapter)">
                      <span>展开</span>
                      <img class="expand-arrow down" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/100.png" alt="" />
                    </div>
                    <div v-else class="sub-expand-toggle" @click="handleIfShow(subChapter, 2, chapter)">
                      <span>收起</span>
                      <img class="expand-arrow up" src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/101.png" alt="" />
                    </div>
                  </div>
                  <!-- 子章节内容 -->
                  <div v-if="subChapter.isshow" class="sub-chapter-content">
                    <!-- Loading 状态 -->
                    <div v-if="subChapterLoading" class="loading-container">
                      <i class="el-icon-loading"></i>
                      <span>加载中...</span>
                    </div>
                    <!-- 课时列表 -->
                    <template v-else>
                      <div v-for="(lesson, lessonIndex) in gchapterVOList" :key="'lesson-' + lesson.id || lessonIndex" class="lesson-item">
                        <div class="lesson-left-wrapper">
                          <div class="lesson-top">
                            <span class="video-icon">
                              <img src="https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/97.png" alt="">
                            </span>
                            <span class="lesson-name">{{ lesson.sectionName || lesson.name || lesson.title || '未命名课时' }}</span>
                          </div>
                          <div class="lesson-bottom">
                            <div class="progress-bar">
                              <div class="progress-fill" :style="{ width: (lesson.studyRate || 0) + '%' }"></div>
                            </div>
                            <span class="status-tag">{{ lesson.studyRate >= 100 ? '已完成' : '学习中' }}</span>
                          </div>
                        </div>
                        <div v-if="chapter.productLine !== '1'" class="lesson-right">
                          <el-button v-if="lesson.docList && lesson.docList.length > 0" class="action-btn" @click.stop="handleGoData(lesson, 2, chapter)">随堂讲义</el-button>
                          <el-button v-if="lesson.testList && lesson.testList.length > 0" class="action-btn" @click.stop="handleCheckTask(lesson)">随堂测试</el-button>
                          <el-button v-if="lesson.resourceList && lesson.resourceList.length > 0" class="action-btn" @click.stop="handleGoData(lesson, 1, chapter)">随堂资料</el-button>
                          <el-button class="study-btn" @click="handleChecks(lesson, chapter, lessonIndex)">去学习</el-button>
                        </div>
                        <div v-else class="lesson-right">
                          <el-button class="study-btn" @click="handleChecks(lesson, chapter, lessonIndex)">去学习</el-button>
                        </div>
                      </div>
                    </template>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { getInfo } from "@/api/cookies";
import { selectChapterRateBykeIdStudentIdGroupId, selectChapterRateByStatusAndkeIdStudentId } from "@/api/mykecheng";
import { courseCheckPlay } from "@/api/know";
import { AnswerClient } from "@/api/task/answerClient";
import Vue from "vue";

export default {
  name: "CoursePackageContent",
  props: {
    courseList: {
      type: Array,
      default: () => []
    },
    selectedCourseId: {
      type: [String, Number],
      default: null
    },
    currentChapters: {
      type: Array,
      default: () => []
    },
    classesId: {
      type: [String, Number],
      default: null
    },
    type: {
      type: [String, Number],
      default: null
    },
    productLine: {
      type: [String, Number],
      default: null
    },
    yearList: {
      type: Array,
      default: () => []
    },
    selectedYear: {
      type: [String, Number],
      default: null
    },
    isPastCourseMode: {
      type: Boolean,
      default: false
    },
    pastCourses: {
      type: Array,
      default: () => []
    },
    showAllCourses: {
      type: Boolean,
      default: false
    },
    userInfo: {
      type: Object,
      default: () => ({})
    },
    isFreeze: {
      type: Number,
      default: 0
    },
    isOutsourcing: {
      type: Number,
      default: 0
    }
  },
  data() {
    const answerClient = new AnswerClient();
    return {
      courseType: ["直播课", "录播课", "直播课", "直播课", "面授课"],
      gchapterVOList: [],
      subChapterLoading: false,
      answerClient
    };
  },
  computed: {
    displayCourseList() {
      if (this.showAllCourses) {
        return this.courseList;
      }
      return this.courseList.slice(0, 6);
    },
    shouldShowMoreButton() {
      return this.courseList.length > 6;
    }
  },

  methods: {
    formatDate(time) {
      if (!time) return '';
      const date = new Date(time.replace(/-/g, '/'));
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${year}.${month}.${day} ${hours}:${minutes}`;
    },
    handleSelectCourse(course) {
      this.$emit('select-course', course);
    },
    showMoreCourses() {
      this.$emit('toggle-show-all-courses');
    },
    togglePastCourseMode() {
      this.$emit('toggle-past-course-mode');
    },
    handleSelectYear(year) {
      this.$emit('select-year', year);
    },
    handleToggleChapter(chapter) {
      this.$emit('toggle-chapter', chapter);
    },
    handleOpenCourseMaterial(chapter) {
      this.$emit('open-course-material', chapter);
    },
    handleOpenCourseTest(chapter) {
      this.$emit('open-course-test', chapter);
    },
    handleGoData(item, type, items) {
      this.$emit('go-data', item, type, items);
    },
    handleCheckTask(item) {
      this.$emit('check-task', item);
    },
    handleCheck(item, group) {
      this.$emit('check', item, group);
    },
    handleCheckXbk(item, group) {
      this.$emit('check-xbk', item, group);
    },
    handleChecks(item, group, index) {
      this.$emit('checks', item, group, index);
    },
    async handleIfShow(row, i, chapter) {
      this.gchapterVOList = [];
      if (i == 1) {
        const loading = this.$loading({
          lock: true,
          text: '加载中',
          spinner: '',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        try {
          this.subChapterLoading = true;
          const res = await selectChapterRateBykeIdStudentIdGroupId({
            keId: chapter.id,
            groupId: row.id,
            studentId: this.userInfo.id
          });

          chapter.chapterNewVOS.forEach((e) => {
            e.isshow = false;
          });

          if (res.code == 0 && res.msg && res.msg.length > 0) {
            this.gchapterVOList = res.msg;
          } else {
            this.gchapterVOList = [
              
            ];
          }
          row.isshow = true;
          this.subChapterLoading = false;
          this.$forceUpdate();
        } catch (error) {
          console.error("获取子章节数据失败", error);
          chapter.chapterNewVOS.forEach((e) => {
            e.isshow = false;
          });
          this.gchapterVOList = [
          
          ];
          row.isshow = true;
          this.subChapterLoading = false;
          this.$forceUpdate();
        } finally {
          loading.close();
        }
      } else {
        row.isshow = false;
        this.$forceUpdate();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.main-content {
  display: flex;
  gap: 16px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
}

.left-sidebar {
  width: 200px;
  background: #f8f9fa;
  padding: 16px 0;
  max-height: calc(100vh - 200px);
  overflow-y: auto;

  .course-nav-item {
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.3s;
    border-left: 3px solid transparent;
    margin: 0 8px 8px 8px;
    border-radius: 2px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    background: #FFFFFF;
    min-height: 69px;

    &:hover {
      background: #fff;
    }

    &.active {
      background: #ECF2FF;
      border-left-color: #4a6af0;

      .course-name {
        color: #4a6af0;
        font-weight: 600;
      }
    }

    .course-name {
      font-size: 16px;
      color: #333;
      font-weight: 500;
      flex: 1;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .course-types {
      display: flex;
      flex-direction: column;
      gap: 4px;

      .type-tag {
        padding: 2px 8px;
        border-radius: 2px;
        font-size: 11px;
        border: 1px solid;
        text-align: center;
        white-space: nowrap;

        &.live-tag {
          background: #fff;
          color: #ff6b00;
          border-color: #ff6b00;
        }

        &.record-tag {
          background: #fff;
          color: #4a6af0;
          border-color: #4a6af0;
        }
      }
    }
  }

  .more-courses {
    padding: 16px 20px;
    text-align: center;
    color: #999;
    font-size: 12px;
    cursor: pointer;
    transition: color 0.3s;

    &:hover {
      color: #4a6af0;
    }

    .arrow {
      margin-left: 4px;
      display: inline-block;
      transition: transform 0.3s;
    }
  }
}

.right-content {
  flex: 1;

  .section-header-wrapper {
    background: #F3F7FA;
    padding: 11px;
    padding-right: 30px;
    margin-bottom: 20px;

    .section-header {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .history-title {
        font-size: 14px;
        color: #1C81F5;
        cursor: pointer;
      }

      >div {
        cursor: pointer;
      }

      .eye-icon {
        font-size: 18px;
        cursor: pointer;
        color: #1C81F5;
        margin-left: 7px;
      }
    }
  }

  .year-selector-wrapper {
    margin-top: 8px;
    display: flex;
    justify-content: flex-end;

    .year-selector {
      display: flex;
      gap: 4px;
      background: #F3F7FA;
      padding: 4px;
      border-radius: 8px;

      .year-item {
        padding: 4px 20px;
        border-radius: 4px;
        color: #333;
        font-size: 14px;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.3s;

        &.active {
          background: #fff;
          color: #1C81F5;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
        }

        &:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .chapter-list {
    .chapter-item {
      border-bottom: 1px dotted #ccc;
      padding: 12px 0;
      overflow: visible;

      &:last-child {
        border-bottom: none;
      }

      .chapter-main {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 15px;

        .chapter-left {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 8px;

          .chapter-row {
            display: flex;
            align-items: center;
            justify-content: space-between;

            &:first-child {
              gap: 12px;
              justify-content: flex-start;
            }

            .type-badge {
              display: inline-block;
              padding: 2px 8px;
              border-radius: 2px;
              font-size: 12px;
              font-weight: 500;

              &.live-badge {
                background: rgba(255, 107, 0, 0.1);
                color: #ff6b00;
                border: 1px solid #ff6b00;
              }

              &.record-badge {
                background: rgba(74, 106, 240, 0.1);
                color: #4a6af0;
                border: 1px solid #4a6af0;
              }
            }

            .chapter-name {
              font-size: 15px;
              color: #333;
              font-weight: 500;
            }

            .chapter-stats {
              display: flex;
              gap: 24px;

              .stat-item {
                font-size: 13px;
                color: #666;
              }
            }
          }
        }

        .chapter-right {
          display: flex;
          gap: 12px;
          align-items: center;

          .action-btn {
            padding: 5px 10px;
            border: 1px solid #2586F5;
            color: #348EF6;
            background: #fff;
            border-radius: 3px;
            font-size: 13px;
            cursor: pointer;
            transition: all 0.3s;

            &:hover {
              background: #348EF6;
              color: #fff;
              border: 1px solid #348EF6;
            }
          }

          .expand-toggle {
            display: flex;
            align-items: center;
            gap: 4px;
            color: #666;
            font-size: 13px;
            cursor: pointer;
            transition: color 0.3s;

            &:hover {
              color: #4a6af0;
            }

            .expand-arrow {
              display: inline-block;
              transition: transform 0.3s;
              width: 13px;
              height: 10px;
            }
          }
        }
      }

      .chapter-details {
        padding: 0;
        margin-top: 0;
        background: #f8f9fa;

        /* 直播课小节项样式（图一） */
        .section-item.live-section {
          padding: 12px 20px;
          margin-bottom: 0;
          background: #f8f9fa;
          border-bottom: 1px dotted #ccc;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: stretch;

          .live-section-left-wrapper {
            flex: 1;
            display: flex;
            flex-direction: column;
            gap: 8px;
          }

          .live-section-top {
            display: flex;
            align-items: center;
            gap: 8px;

            .video-icon {
              font-size: 16px;

              img {
                width: 21px;
                height: 17px;
              }
            }

            .section-name {
              font-size: 14px;
              color: #333;
            }

            .video-tag {
              font-size: 11px;
              color: #2E2E2E; 
              border-radius: 2px;
              width: 61px;
              height: 17px;
              background: url(https://staticfile.xlcwx.com/m-images/yth/lzimg/xlcxx/94.png) no-repeat center center;
              background-size: 100% 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              
              img {
                width: 15px;
                height: 9px;
                margin-right: 3px;
              }
            }
          }

          .live-section-bottom {
            display: flex;
            align-items: center;
            gap: 12px;

            .section-time {
              font-size: 12px;
              color: #666;
              white-space: nowrap;
            }

            .progress-bar {
              flex: 1;
              height: 6px;
              background: #e0e0e0;
              border-radius: 3px;
              overflow: hidden;
              min-width: 120px;

              .progress-fill {
                height: 100%;
                background: #4a6af0;
                border-radius: 3px;
                transition: width 0.3s;
              }
            }

            .status-tag {
              font-size: 12px;
              color: #666;
              white-space: nowrap;
            }
          }

          .live-section-right {
            display: flex;
            gap: 8px;
            align-items: center;
            margin-left: 20px;
            width: 350px;
            justify-content: flex-end;

            .action-btn {
              padding: 4px 14px;
              border: 1px solid #4a6af0;
              color: #4a6af0;
              background: #fff;
              border-radius: 2px;
              font-size: 12px;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                background: #4a6af0;
                color: #fff;
              }
            }

            .study-btn {
              padding: 10px 17px;
              border: none;
              color: #fff;
              background: #1C81F5;
              border-radius: 17px;
              font-size: 16px;
              cursor: pointer;
              transition: all 0.3s;

              &:hover {
                background: #3a5ae0;
              }
            }
          }
        }

        .sub-chapter-item {
          border-bottom: 1px dotted #ccc;

          .sub-chapter-header {
            display: flex;
            align-items: center;
            padding: 14px 20px;
            background: #F3F7FA;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .sub-chapter-icon {
              font-size: 16px;
              margin-right: 8px;

              img {
                width: 16px;
                height: 10px;
              }
            }

            .sub-chapter-name {
              flex: 1;
              font-size: 15px;
              color: #2D6BEF;
              font-weight: Bold;
            }

            .sub-expand-toggle {
              display: flex;
              align-items: center;
              gap: 4px;
              color: #666;
              font-size: 13px;
              cursor: pointer;
              transition: color 0.3s;

              &:hover {
                color: #4a6af0;
              }

              .expand-arrow {
                display: inline-block;
                transition: transform 0.3s;
                width: 13px;
                height: 10px;
              }
            }
          }

          /* 录播课小节项样式（图二） */
          .sub-chapter-content {
            /* Loading 容器样式 */
            .loading-container {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 30px 20px;
              color: #999;
              font-size: 14px;

              i {
                margin-right: 8px;
                font-size: 16px;
                color: #4a6af0;
              }
            }

            .lesson-item {
              padding: 10px 20px;
              background: #fff;
              border-bottom: 1px dotted #ccc;
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: stretch;

              .lesson-left-wrapper {
                flex: 1;
                display: flex;
                flex-direction: column;
                gap: 8px;
              }

              .lesson-top {
                display: flex;
                align-items: center;
                gap: 8px;

                .video-icon {
                  font-size: 14px;

                  img {
                    width: 21px;
                    height: 17px;
                  }
                }

                .lesson-name {
                  font-size: 13px;
                  color: #333;
                }
              }

              .lesson-bottom {
                display: flex;
                align-items: center;
                gap: 12px;

                .progress-bar {
                  flex: 1;
                  height: 6px;
                  background: #e0e0e0;
                  border-radius: 3px;
                  overflow: hidden;
                  min-width: 120px;

                  .progress-fill {
                    height: 100%;
                    background: #4a6af0;
                    border-radius: 3px;
                    transition: width 0.3s;
                  }
                }

                .status-tag {
                  font-size: 12px;
                  color: #666;
                  white-space: nowrap;
                }
              }

              .lesson-right {
                display: flex;
                gap: 8px;
                align-items: center;
                margin-left: 20px;
                width: 350px;
                justify-content: flex-end;

                .action-btn {
                  padding: 5px 10px;
                  border: 1px solid #2586F5;
                  color: #348EF6;
                  background: #fff;
                  border-radius: 3px;
                  font-size: 13px;
                  cursor: pointer;
                  transition: all 0.3s;

                  &:hover {
                    background: #348EF6;
                    color: #fff;
                    border: 1px solid #348EF6;
                  }
                }

                .study-btn {
                  padding: 10px 17px;
                  border: none;
                  color: #fff;
                  background: #1C81F5;
                  border-radius: 17px;
                  font-size: 16px;
                  cursor: pointer;
                  transition: all 0.3s;

                  &:hover {
                    background: #3a5ae0;
                  }
                }
              }

              &:last-child {
                border-bottom: none;
              }
            }
          }

          &:last-child {
            border-bottom: none;
          }
        }
      }
    }
  }
}
</style>
